import 'bootstrap';
import 'slick-carousel';
import './modules/burger-rotate.js';
import './modules/carousels.js';
import './modules/toggle-switches.js';
import './modules/filter.js';



